<template>
  <div class="user-detail-container">
    <div class="user-info">
      <div class="id-box">
        <div class="text">用户ID:</div>
        <div class="value">
          <span>{{userDetail.id}}</span>
          <Icon :file="copy" class="icon"  @click="copyMessage"  :width="'18px'" :height="'18px'"/>
        </div>
      </div>
      <div class="cumulative-item first">
        <span class="text">累计打卡天数:</span>
        <span class="value">{{userDetail.cumulativeClockinCount || 0}}</span>
      </div>
      <div class="cumulative-item">
        <span class="text">连续打卡天数:</span>
        <span class="value">{{userDetail.singinNum || 0}}</span>
      </div>
    </div>
    <div class="cumulative-item">
      <span class="text">使用药品:</span>
      <span class="value">{{productStr || '/'}}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Icon from '../../../../common/Icon.vue'
import copy from '../../../../../assets/icon/copy.svg';
import { TUIGlobal } from '@tencentcloud/universal-api';
import { transformTextWithKeysToEmojiNames } from '../../../emoji-config';
import { isUniFrameWork } from '../../../../../utils/env';
import { Toast } from '@/TUIKit/components/common/Toast/index';
// uni-app conditional compilation will not run the following code
// #ifndef APP || APP-PLUS || MP || H5
import CopyManager from '../../../utils/copy';
import { onMounted, ref, watchEffect } from 'vue';
import { queryUserProductApi } from '@/utils/user';
// #endif

async function copyMessage() {
  if (isUniFrameWork) {
    TUIGlobal?.setClipboardData({
      data: transformTextWithKeysToEmojiNames(props.userDetail.id),
    });
  } else {
    // uni-app conditional compilation will not run the following code
    // #ifndef APP || APP-PLUS || MP || H5
    CopyManager.copySelection(props.userDetail.id);
    // #endif
  }
  Toast({
      message: '复制成功',
      type: 'success',
    });
}

const props = defineProps({
  userDetail: {
    type: Object,
    default: () => ({})
  }
})

const productStr = ref('')

const getProduct = async ()=>{
  try {
		const res = await queryUserProductApi({customerId: props.userDetail.id})
		const result =  res?.body?.list || []

    if(result.length){
      productStr.value = result?.map((item:any) => item.name).join('、') 
    }
	} catch (err:any) {
		console.log(err);
	}
}


watchEffect(() => {
  if(props.userDetail.id){
    getProduct()
  }
})
</script>

<style scoped lang="scss">
.user-detail-container{
  margin-top: 4px;
  padding: 8px 18px;
  padding-bottom: 12px;
  border: 1px solid #D9D9D9;
  font-size: 14px;
  .user-info{
    display: flex;
    align-items: center;
    .cumulative-item{
      margin-left: 15px;
      margin-top: 0;
    }
  }
  .id-box{
    display: flex;
    align-items: center;
    .text{
      color: #999;
    }
    .value{
      display: flex;
      align-items: center;
      // margin-top: 8px;
      margin-left: 8px;
      font-size: 14px;
      color: #333;
      .icon{
        margin-left: 4px;
        color: #0499b5;
      }
    }
  }
  .cumulative-item{
    margin-top: 3px;
    .text{
      color: #999999;
    }
    .value{
      margin-left: 7px;
      color: #333333;
    }
  }
  .first{
   margin-top: 18px; 
  }
}
</style>
